import { Plus, Search, Trash2, MessageSquare } from "lucide-react";

export function ChatSidebar({ conversations, activeId, search, onSearch, onNew, onOpen, onDelete, disabled }) {
  const filtered = conversations.filter(c => !search || (c.title || "").toLowerCase().includes(search.toLowerCase()));
  return (
    <aside className="w-72 shrink-0 border-r border-[var(--aria-border)] bg-[var(--aria-surface)] flex flex-col">
      <div className="p-4 border-b border-[var(--aria-border)] space-y-3">
        <button onClick={onNew} disabled={disabled} data-testid="new-chat-button"
          className="w-full flex items-center gap-2 justify-center px-3 py-2 rounded-md bg-[var(--aria-primary)] text-white hover:bg-[var(--aria-primary-hover)] text-sm font-medium">
          <Plus size={16} /> New conversation
        </button>
        <div className="relative">
          <Search size={14} className="absolute left-2.5 top-2.5 text-[var(--aria-text-muted)]" />
          <input data-testid="chat-search" value={search} onChange={e => onSearch(e.target.value)} placeholder="Search history…"
            className="w-full pl-8 pr-3 py-2 text-sm rounded-md border border-[var(--aria-border)] bg-[var(--aria-bg)] outline-none focus:ring-2 focus:ring-[var(--aria-primary)]" />
        </div>
      </div>
      <div className="flex-1 overflow-y-auto p-2 no-scrollbar">
        {filtered.length === 0 && <div className="text-xs text-[var(--aria-text-muted)] p-4 text-center">No conversations yet.</div>}
        {filtered.map(c => (
          <button key={c.conversation_id} disabled={disabled} onClick={() => onOpen(c.conversation_id)} data-testid={`conv-${c.conversation_id}`}
            className={`w-full text-left p-3 rounded-md group flex items-start gap-2 mb-1 ${activeId === c.conversation_id ? "bg-[var(--aria-primary)]/10" : "hover:bg-slate-100 dark:hover:bg-white/5"}`}>
            <MessageSquare size={14} className="mt-0.5 text-[var(--aria-text-muted)] shrink-0" />
            <div className="flex-1 min-w-0">
              <div className="text-sm font-medium truncate">{c.title || "Untitled"}</div>
              <div className="text-xs text-[var(--aria-text-muted)] truncate">{(c.messages?.[0]?.content || "").slice(0, 50)}</div>
            </div>
            <Trash2 size={14} onClick={(e) => onDelete(c.conversation_id, e)} className="opacity-0 group-hover:opacity-100 text-red-500 hover:text-red-700" />
          </button>
        ))}
      </div>
    </aside>
  );
}
